// extracted by mini-css-extract-plugin
export default {"row":"viewItem_row__3TfWf","col":"viewItem_col__DsESY","card":"viewItem_card__utUBk"};